<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body">
      <vs-row vs-justify="center" vs-align="center" class="p-3">
        <vs-col>
          <div class="pb-5 p-6">
            <div class="truncate">
              <h2 class="mb-1 font-bold"
                  :class="{'text-success': this.trend === 'up', 'text-danger': this.trend === 'down', 'text-warning': this.trend === 'same'}">
                <feather-icon v-if="trendIcon" :icon="trendIcon" class="p-3 inline-flex rounded-full"></feather-icon>
                {{ current }} <span style="font-size:.5em;color:black;">({{ previous }})</span>
              </h2>
              <span>{{ label }}</span>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </vx-card>
</template>

<script>

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine';

export default {
  name: 'registrations-trend-card',
  components: {StatisticsCardLine},
  props: {
    data: Object,
    program: String,
    color: String,
    label: String,
    period: 'MONTH' | 'QUARTER' | 'YEAR'
  },
  data () {
    return {
      current: null,
      previous: null,
      trend: null
    };
  },
  computed: {
    trendIcon () {
      if (!this.trend) return null;
      if (this.trend === 'up') {
        return 'TrendingUpIcon';
      } else if (this.trend === 'down') {
        return 'TrendingDownIcon';
      } else if (this.trend === 'same') {
        return 'ActivityIcon';
      }
      return null;
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const thisPeriod = root.nested.find(n => n.name === `THIS_${this.period}`);
        const lastPeriod = root.nested.find(n => n.name === `LAST_${this.period}`);

        let thisSource = thisPeriod;
        let lastSource = lastPeriod;
        if (this.program) {
          thisSource = thisPeriod.nested.find(n => n.name === 'PROGRAMS').buckets.find(b => b.key === this.program);
          lastSource = lastPeriod.nested.find(n => n.name === 'PROGRAMS').buckets.find(b => b.key === this.program);
        }

        this.current = thisSource ? thisSource.nested.find(n => n.name === 'COUNT').value : 0;
        this.previous = lastSource ? lastSource.nested.find(n => n.name === 'COUNT').value : 0;
        const approxeq = (v1, v2, epsilon) => Math.abs(v1 - v2) <= epsilon;

        if (this.current === this.previous) {
          this.trend = 'same';
        } else if (this.previous > this.current) {
          if (approxeq(this.previous, this.current, .1 * Math.max(this.previous, this.current))) {
            this.trend = 'same';
          } else {
            this.trend = 'down';
          }
        } else if (this.previous < this.current) {
          this.trend = 'up';
        }
      }
    }
  }
};
</script>

<style scoped>

</style>
